//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'PtTab',
  props: {
    selectedIndex: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Array,
      default: function () { return []; },
    },
  },
  data: function data() {
    return {
      tabs: [],
    };
  },
  mounted: function mounted() {
    if (this.selectedIndex) {
      this.$children[this.selectedIndex - 1].isActive = true;
    } else {
      this.$children[0].isActive = true;
    }
    if (this.disabled) {
      for (var index = 0; index < this.disabled.length; index += 1) {
        this.$children[this.disabled[index] - 1].isDisabled = true;
      }
    }
    this.tabs = this.$children;
  },
  methods: {
    selectTab: function selectTab(selectedTab, index) {
      if (!selectedTab.isDisabled) {
        this.tabs.forEach(function (tab) {
          var item = tab;
          item.isActive = item.name === selectedTab.name;
        });
      }
      this.$emit('selected-tab-info', selectedTab.name, index);
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "pt-tabs" }, [
    _c(
      "ul",
      { staticClass: "pt-tabs-ul" },
      _vm._l(_vm.tabs, function(tab, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "pt-tabs-li",
            class: { "pt-tabs-li__active": tab.isActive }
          },
          [
            _c(
              "a",
              {
                staticClass: "pt-tabs-li-anchor",
                class: {
                  "pt-tabs-li-anchor__disabled": tab.isDisabled,
                  "pt-tabs-li-anchor__active": tab.isActive
                },
                attrs: { href: tab.href },
                on: {
                  click: function($event) {
                    $event.preventDefault();
                    _vm.selectTab(tab, index);
                  }
                }
              },
              [_vm._v(_vm._s(tab.name))]
            )
          ]
        )
      })
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pt-tabs-details" }, [_vm._t("default")], 2)
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Tab = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
//
//
//
//
//

var script$1 = {
  name: 'PtTabItem',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data: function data() {
    return {
      isActive: this.isActive,
    };
  },
  computed: {
    href: function href() {
      return ("#" + (this.name.toLowerCase().replace(/ /g, '-')));
    },
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isActive
    ? _c("div", { staticClass: "pt-tab-item" }, [_vm._t("default")], 2)
    : _vm._e()
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var TabItem = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

export { Tab as PtTab, TabItem as PtTabItem };
